import { configureStore } from '@reduxjs/toolkit'
import counterReducer from './slices/counterSlice'
import wishlistReducer from './slices/wishlistSlice'
import PDPreducer from './slices/PDPSlice'

const loadStateFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem('wishlist')
    if (serializedState === null) {
      return undefined
    }
    return { wishlist: JSON.parse(serializedState) }
  } catch (err) {
    console.error('Failed to load state from localStorage:', err)
    return undefined
  }
}

const saveStateToLocalStorage = (state: any) => {
  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem('wishlist', serializedState)
  } catch (err) {
    console.error('Failed to save state to localStorage:', err)
  }
}

const preloadedState = loadStateFromLocalStorage()

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    wishlist: wishlistReducer,
    PDP: PDPreducer
  },
  preloadedState,
  devTools: process.env.NODE_ENV !== 'production',
})

store.subscribe(() => {
  saveStateToLocalStorage(store.getState().wishlist)
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
